import React from 'react'
import logo from '../../assets/img/logo.png'
import {
  AddressLine, Boxes, HOME_ID_GAPS, ID_CARD_GAPS, L, Mark, Sq, blank,
} from './docParts'
import { admissionBeYear, classLabel, dateParts, digits, money, nameParts } from './printFormat'

// ใบมอบตัวนักเรียน — ยกโครงมาจากส่วน print-doc2 ของระบบเดิม
// ใบนี้เหมือนกันทั้งแผนกมัธยมและอนุบาล-ประถม (ของเดิมก็เป็นสำเนาเดียวกันสองไฟล์)

// บล็อกบิดา/มารดา ในใบมอบตัวมีรายละเอียดมากกว่าในใบสมัคร (อาชีพ รายได้ เบอร์โทร)
const ParentDetail = ({ index, label, row, prefix }) => {
  const n = nameParts(row[`${prefix}Name`])
  const bd = dateParts(row[`${prefix}Birthdate`])
  return (
    <>
      {index}. ชื่อ-สกุล {label}<L value={n.full} pad={11} />
      <span className="me-1">เลขประจำตัวประชาชน</span>
      <Boxes chars={digits(row[`${prefix}IdCard`], 13)} gaps={ID_CARD_GAPS} />
      <br />
      เกิดวันที่<L value={bd && bd[0]} pad={2} className="mt-1" />
      เดือน<L value={bd && bd[1]} pad={9} />
      พ.ศ<L value={bd && bd[2]} pad={3} />
      เชื้อชาติ<L value={row[`${prefix}Race`]} pad={3} />
      สัญชาติ<L value={row[`${prefix}Nationality`]} pad={3} />
      <Mark on={row[`${prefix}Life`] === '1'} className="me-1" />ยังมีชีวิตอยู่
      <Mark on={row[`${prefix}Life`] === '0'} className="me-1 ms-2" />เสียชีวิต
      <br />
      อาชีพ<L value={row[`${prefix}Job`]} pad={8} />
      สถานที่ทำงาน<L value={row[`${prefix}WorkPlace`]} pad={8} />
      รายได้ / เดือน<L value={money(row[`${prefix}AnnualIncome`])} pad={4} />บาท&nbsp;
      เบอร์โทรศัพท์<L value={row[`${prefix}Phone`]} pad={5} />
      <br />
    </>
  )
}

export default function SurrenderDoc({ row, school, schoolAddress, principal }) {
  const beYear = admissionBeYear(row.regis_date)
  const student = nameParts(row.st_name)
  const guardian = nameParts(row.st_parentname)
  const bd = dateParts(row.st_birthdate)
  const isOtherGuardian = row.st_parent === 'other'

  return (
    <div className="adm-doc adm-doc-surrender">
      <center>
        <table>
          <tbody>
            <tr>
              <td>{blank(8)}</td>
              <td className="text-center pt-1 pb-1 ps-4 pe-4">
                <img src={logo} width={100} height={100} alt="" />
                <h4 className="fw-bold text-center mt-1">
                  ใบมอบตัวนักเรียน ปีการศึกษา {beYear}
                </h4>
                <h5 className="fw-bold text-center">{school} {schoolAddress}</h5>
              </td>
              <td className="p-1" rowSpan={2}>
                <div className="photo-bt-label p-1 fw-bold">
                  <br /><br /><br /><br />
                  <span className="ms-4">ติดรูปถ่าย ขนาด 1.5 นิ้ว</span>
                  <br /><br /><br />
                  เลขประจำตัวนักเรียน
                  <L value={String(row.st_idnumber || '').trim()} pad={2} className="mt-2" />
                  <br />
                  ชั้นเรียนสามัญ
                  <L value={row.regis_academicClass ? `${classLabel(row.regis_academicClass)} /  ` : ''} pad={4} />
                  <br />
                  ชั้นเรียนศาสนา<L value="" pad={4} />
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan={2} className="p-1">
                <u className="fw-bold fs-6">ข้อมูลนักเรียน</u>
                <br />
                {row.st_name ? (
                  <>
                    1. ชื่อ<L value={student.prefixFirst} />
                    นามสกุล<L value={student.last} />
                  </>
                ) : (
                  <>
                    (ด.ช./ด.ญ./นาย/นางสาว)<L value="" pad={11} />
                    นามสกุล<L value="" pad={11} />
                  </>
                )}
                <br />
                <span className="me-1">เลขประจำตัวประชาชน</span>
                <Boxes chars={digits(row.st_idcard, 13)} gaps={ID_CARD_GAPS} />
                <span className="me-1" />
                ศาสนา<L value={row.st_religion} pad={5} />
                <br />
                เกิดวันที่<L value={bd && bd[0]} pad={1} />
                เดือน<L value={bd && bd[1]} pad={5} />
                พ.ศ<L value={bd && bd[2]} pad={2} />
                เชื้อชาติ<L value={row.st_race} pad={2} />
                สัญชาติ<L value={row.st_nationality} pad={2} />
                หมู่เลือด<L value={row.st_blood} pad={1} />
              </td>
            </tr>

            <tr>
              <td colSpan={3} className="p-1">
                2. ที่อยู่ตามสำเนาทะเบียนบ้าน เลขรหัสประจำบ้าน {blank(1)}
                <Boxes chars={digits(row.st_homeID, 11)} gaps={HOME_ID_GAPS} />
                <br />
                <AddressLine
                  label="บ้านเลขที่"
                  detail={row.st_current} subDistrict={row.st_currentSubDistrict}
                  district={row.st_currentDistrict} province={row.st_currentProvince}
                />
                รหัสไปรษณีย์<L value={row.st_zipcode} pad={2} />
                <br />
                3. มีพี่น้อง<L value={row.st_sibling} pad={0} />คน&nbsp;
                เป็นบุตรคนที่<L value={row.st_childnumber} pad={0} />คน&nbsp;
                จำนวนพี่น้องที่เรียนอยู่<L value={row.st_studyingSibling} pad={0} />คน&nbsp;
                โรคประจำตัว<L value={row.st_syndrome} pad={5} />
                แพ้ยา<L value={row.st_drug} pad={4} />
                แพ้อาหาร<L value={row.st_food} pad={3} />
                <br />
                4. โรงเรียนเดิมชื่อ<L value={row.st_prevAcademicSchool} pad={12} />
                ตำบล<L value={row.st_prevAcademicSubDistrict} pad={6} />
                อำเภอ<L value={row.st_prevAcademicDistrict} pad={6} />
                จังหวัด<L value={row.st_prevAcademicProvince} pad={6} />
                <br />
                5. สถานภาพสมรสของบิดา มารดา
                <Sq on={row.st_parentStatus === 'togather'} className="ms-3 me-1" />
                อยู่ด้วยกัน
                <Sq on={row.st_parentStatus === 'separated'} className="ms-3 me-1" />
                แยกกันอยู่
                <Sq on={row.st_parentStatus === 'divorce'} className="ms-3 me-1" />
                หย่าร้าง
              </td>
            </tr>

            <tr>
              <td className="p-1" colSpan={3}>
                <u className="fw-bold fs-6">ข้อมูลบิดา/มารดา</u>
                <br />
                <ParentDetail index={1} label="บิดา" row={row} prefix="st_father" />
                <ParentDetail index={2} label="มารดา" row={row} prefix="st_mother" />
              </td>
            </tr>

            <tr>
              <td className="p-1" colSpan={3}>
                <u className="fw-bold">ที่อยู่ปัจจุบันของนักเรียน (กรณีไม่ได้อยู่กับบิดา/มารดา)</u>
                <br />
                ชื่อ<L value={isOtherGuardian ? guardian.prefixFirst : ''} pad={8} />
                นามสกุล<L value={isOtherGuardian ? guardian.last : ''} pad={7} />
                เกี่ยวข้องกับนักเรียนเป็น<L value={isOtherGuardian ? row.st_parentRelation : ''} pad={5} />
                <br />
                <AddressLine
                  detail={isOtherGuardian ? row.st_parentAddress : ''}
                  subDistrict={isOtherGuardian ? row.st_parentSubDistrict : ''}
                  district={isOtherGuardian ? row.st_parentDistrict : ''}
                  province={isOtherGuardian ? row.st_parentProvince : ''}
                />
                รหัสไปรษณีย์<L value={isOtherGuardian ? row.st_parentZipcode : ''} pad={3} />
                <br />
                อาชีพ<L value={isOtherGuardian ? row.st_parentjob : ''} pad={8} />
                สถานที่ทำงาน<L value={isOtherGuardian ? row.st_parentWorkPlace : ''} pad={8} />
                รายได้ / เดือน<L value={isOtherGuardian ? money(row.st_parentannualincome) : ''} pad={3} />บาท&nbsp;
                เบอร์โทรศัพท์<L value={isOtherGuardian ? row.st_parentPhone : ''} pad={6} />
              </td>
            </tr>

            <tr>
              <td className="p-1" colSpan={3}>
                <u className="fw-bold">กรณีฉุกเฉินสามารถติดต่อเพื่อนบ้านหรือญาติสนิท</u>
                <br />
                ชื่อ<L value={row.st_emergencyFirstName} pad={12} />
                นามสกุล<L value={row.st_emergencyLastName} pad={12} />
                เบอร์โทรศัพท์<L value={row.st_emergencyPhone} pad={10} />
              </td>
            </tr>

            <tr>
              <td className="pt-3" colSpan={3}>
                {blank(5)}ขอรับรองว่าผู้สมัครเป็นผู้ที่มีความประพฤติเรียบร้อยและมีคุณสมบัติอื่นๆ ตามข้อบังคับของโรงเรียนทุกประการ ข้าพเจ้ายินดีปฏิบัติตามกฎระเบียบ ข้อบังคับ
                <br />การบริหารจัดการ ตลอดจนค่าใช้จ่ายต่างๆ ที่โรงเรียนกำหนด พร้อมทั้งให้ความร่วมมือกับโรงเรียนทุกประการจนพ้นสภาพการเป็นนักเรียน
              </td>
            </tr>

            <tr>
              <td className="pt-5" colSpan={3}>
                {blank(24)}ลงชื่อ.......................................................ผู้ปกครอง
                <br />
                {blank(25)}(..............................................................)
                <br />
                {blank(22)}วันที่ ...............เดือน ....................................พ.ศ. ........................
                <br /><br />
                {blank(24)}ลงชื่อ........................................................ผู้อำนวยการโรงเรียน
                <br />
                {blank(27)}({principal})
                <br />
                {blank(22)}วันที่ ...............เดือน ......................................พ.ศ. .........................
              </td>
            </tr>
          </tbody>
        </table>
      </center>
    </div>
  )
}
